<template>
<div>
  <div>

    <vs-row class="mb-4">
    <vs-col class="w-full">
      <vs-alert :active="seeHistorial" icon="new_releases" color="danger">
        <div>
           {{$t('show_historial_info_message')}}
        </div>
      </vs-alert>
    </vs-col>
  </vs-row>

     <vx-card v-if="seeHistorial" noShadow ref="filterCard" :title="$t('historial_annual_plan')" color="blue" class="user-list-filters mb-8" v-show="hasPermission(['IU EHS VIEW'])">
       <template slot="actions">
          <vx-tooltip
            delay="0.5s"
            text="Ver Actual"
            tooltipPosition="top"
          >
            <feather-icon
              icon="ArrowLeftIcon"
              svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
              @click="onChange()"
            />
          </vx-tooltip>
        </template>
      <vs-row>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-xs="12" vs-sm="6" vs-lg="6" class="px-1">
          <v-select
                  v-model="selectedClient"
                  :options="clientFilter"
                  :reduce="client => client.ClientId"
                  label="ShortName"
                  name="ClientSelect"
                  class="w-full"
                  @input="onChangeHistorial()"
                  />
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-xs="12" vs-sm="4" vs-lg="4" class="px-1">
        <v-select
                  v-model="historial_yearSelected"
                  :options="historial_years"
                  class="w-full"
                  @input="onChangeHistorial()"
                  />
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-xs="12" vs-sm="2" vs-lg="2" class="px-1">
             <vs-button color="success" type="filled" class="w-full" @click="download(resHeight)">{{$t('download')}} PDF</vs-button>
        </vs-col>
  
      </vs-row>
    </vx-card>
     <vx-card v-else noShadow ref="filterCard" :title="$t('select_a_client')" class="user-list-filters mb-8" v-show="hasPermission(['IU EHS VIEW'])">
      <template slot="actions">
          <vx-tooltip
            delay="0.5s"
            text="Ver Historial"
            tooltipPosition="top"
          >
            <feather-icon
              icon="ClockIcon"
              svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
              @click="onChangeHistorial()"
            />
          </vx-tooltip>
        </template>
      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-xs="12" vs-sm="6" vs-lg="6" class="px-1">
           <v-select
                  v-model="selectedClient"
                  :options="clientFilter"
                  :reduce="client => client.ClientId"
                  label="ShortName"
                  name="ClientSelect"
                  class="w-full"
                  @input="onChange()"
                  />
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-xs="12" vs-sm="4" vs-lg="4" class="px-1">
        <v-select
                  v-model="yearSelected"
                  :options="years"
                  class="w-full"
                  @input="onChange()"
                  />
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-xs="12" vs-sm="2" vs-lg="2" class="px-1">
             <vs-button color="success" type="filled" class="w-full" @click="download(resHeight)">{{$t('download')}} PDF</vs-button>
        </vs-col>
      </vs-row>
    </vx-card>

    

  <vx-card v-show="hasPermission(['IU EHS VIEW'])">
    <div id="gantt-chart"  ref="content" class="overflow test">
        <div class="vx-card__header mb-3"><div class="vx-card__title"><h4 class="">{{TitleGantt}}</h4><!----></div><!----></div>
        <GSTC  id="gantt" :config="config" @state="onState"/>
    </div>
  </vx-card>
  </div>
</div>
</template>
<script>
import GSTC from 'vue-gantt-schedule-timeline-calendar'
import jsPDF from 'jspdf' 
import domtoimage from 'dom-to-image'
import html2canvas from "html2canvas"
import { duration } from 'moment'
import gantt from '@/http/requests/gantt/index.js'
import vSelect from 'vue-select'
import client from '@/http/requests/client'

window.html2canvas = html2canvas

const subs = []

export default {
  components: {
    GSTC,
    'v-select': vSelect,
  },  
  data () {
    return {
      years:[
        new Date().getFullYear(),
        new Date().getFullYear() - 1,
        new Date().getFullYear() - 2,
        new Date().getFullYear() - 3,
        new Date().getFullYear() - 4
      ],
      yearSelected:new Date().getFullYear(),
      historial_years:[],
      seeHistorial:false,
      TitleGantt:this.$i18n.messages[this.$i18n.locale].annual_plan,
      historial_yearSelected:'',
      clients: [],
      clientFilter: [],
      selectedClient: null, 
      resHeight: null,
      config: {
        headerHeight: 50,
        height: 500,
        list: {
          toggle :{
            display : true
          },
          expander:{
            icon:{
              width : 10,
              height : 10,
            }
          },
          rows: {},
          columns: {
            resizeable : false,
            resizer :{
              width :0,
              dots :0
            },
            data: {
              label: {
                id: 'label',
                data: 'label',
                width: 300,
                expander:true,
                header: {
                  content: this.$i18n.messages[this.$i18n.locale].permit_name
                }
              },
              usd: {
                id: 'usd',
                width: 100,
                data: 'usd',
                header: {
                  content: 'USD'
                }
              },
              saving: {
                id: 'saving',
                data: 'saving',
                width: 100,
                header: {
                  content: this.$i18n.messages[this.$i18n.locale].savings
                }
              },
              frequency: {
                id: 'frequency',
                data: 'frequency',
                width: 100,
                header: {
                  content: this.$i18n.messages[this.$i18n.locale].frequency || 'frequency'
                }
              }
            }
          }
        },
        chart: {
          calendar: {
            expand: true,
            levels: [
              {
                formats: [
                  {
                    zoomTo: 100,
                    period: 'year',
                    default: true,
                    format ({ timeStart, vido, className }) {
                      return /*vido.html`<div align="center" class="${className}-content gstc-date-small gstc-date-bottom">${timeStart.format(
                        'YYYY'
                      )}</div>`*/null
                    }
                  }
                ]
              },
              {
                main: true,
                formats: [
                  {
                    zoomTo: 26,
                    period: 'month',
                    default: true,
                    className: 'gstc-date-month-level-1',
                    format ({ timeStart, vido, className }) {
                      return vido.html`<div class="${className}-content gstc-date-top">${timeStart.format(
                        'MMM'
                      )}</div>`
                      /*<div class="${className}-content gstc-date-small gstc-date-bottom">${timeStart.format(
                        'YYYY'
                      )}</div>*/
                    }
                  }
                ]
              }
            ]
          },
          items: {  
          },
          time: {
            from: new Date(new Date().getFullYear(), 0, 1).getTime(),
            to: new Date(new Date().getFullYear(),  11, 31).getTime(),
            zoom: 25.6
          }
        },
      }
    }
  },
  beforeMount(){
    this.$store.dispatch('clearGlobalEhsFilter')
    this.$store.dispatch('clearGlobalComplianceFilter')
  },
  created () {
    this.init()
  },
  computed:{
    allowed_to_see_module(){
      let allowed = localStorage.getItem('permissions').includes('IU EHS Module')
      return allowed
    }
  },
  methods: {
    init () {
      gantt.clients()
      .then((res) => {
        this.selectedClient = res.data.default
        this.clients = res.data.clients
        this.clientFilter.push(...res.data.clients)
        this.onChange()
      })
      gantt.historialSelect().then(res => {
        this.historial_years=res.data
        this.historial_yearSelected=this.historial_years[0]
      })
      
    },
    onChange() {
      this.seeHistorial=false
      this.TitleGantt=this.$i18n.messages[this.$i18n.locale].annual_plan +' - '+this.yearSelected +' - '+this.getSelectedClienName()
      if(this.state != null){
        this.onState(this.state,this.selectedClient)
      }
    },
    onChangeHistorial() {
      this.seeHistorial=true
      if(this.state != null){
        this.TitleGantt=this.$i18n.messages[this.$i18n.locale].historial_annual_plan+' - '+this.historial_yearSelected +' - '+this.getSelectedClienName()
        this.onState(this.state,this.selectedClient,0)
      }
    },
    getSelectedClienName(){
      let currentClient= this.clientFilter.filter((item) => {
            return item.ClientId==this.selectedClient
          });
      return currentClient[0].ClientName
    },
    getCanvas(form,a4) {
      form[0].style.width = (a4[0] * 1.33333 - 80);
      return html2canvas(form[0], {
        imageTimeout: 2000,
        removeContainer: true,
      });
    },
    
    download (resHeight) {
      this.$vs.notify({
            color: 'warning',
            title: 'Downloading Pdf',
            text: 'Wait a moment'
          })
      
      html2canvas(this.$refs.content).then(function (canvas) {
          var img = canvas.toDataURL("image/png");
          const alto=canvas.height
          const ancho=canvas.width
          var doc = new jsPDF({
            unit: 'px',
            format: [alto,ancho]
          });
          const imgProps= doc.getImageProperties(img);
          const pdfWidth = doc.internal.pageSize.getWidth();
          const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
          const date = new Date()
          const filename =
          `timechart_${ 
            date.getFullYear() 
          }${(`0${  date.getMonth() + 1}`).slice(-2) 
          }${(`0${  date.getDate()}`).slice(-2) 
          }${(`0${  date.getHours()}`).slice(-2) 
          }${(`0${  date.getMinutes()}`).slice(-2) 
          }${(`0${  date.getSeconds()}`).slice(-2) 
          }.pdf`
          doc.addImage(img, 'JPEG',5,5, (pdfWidth-10), pdfHeight);
          doc.save(filename);        
      });
    },
    onState (state, id = 0, current = 1) {
      this.$vs.loading({
        container: '#gantt-chart',
        scale: 1
      })
      setTimeout(() => {
        this.$vs.loading.close('#gantt-chart > .con-vs-loading')
      }, 2000)
      this.state = state
      if(id != 0){
        if(current == 1){
        gantt.rows(id,this.yearSelected)
        .then((res) => {    
            let rows= {}
            let new_time= {}
            let timeItmes = {}
            let idItem = 1
            let resHeight = (res.data.parents.length + res.data.columns.length)*50
            this.resHeight = resHeight
            let total_savings = 0
            let total_USD  = 0 
            res.data.parents.forEach(element => {
              
                rows[element.parentId] ={
                  id:element.parentId,
                  label:element.parentName,
                  expanded: true,
                  saving: "$ "+parseFloat(element.savings).toFixed(2),
                  usd:  "$ "+parseFloat(element.USD).toFixed(2)
                }
                total_savings += +(element.savings)
                total_USD += +(element.USD)
               
              
            })
          rows['totals'] ={
            id:'totals',
            label:'Totals',
            expanded: false,
            saving: "$ "+parseFloat(total_savings).toFixed(2),
            usd:  "$ "+parseFloat(total_USD).toFixed(2)
          }
          let duration = '';
          res.data.columns.forEach(element => {
            duration = new Date(element.duration).getTime()
            rows[element.childId] = {
              id:element.childId,
              label: element.childName,
              expanded: false,
              parentId:element.parentId,
              saving: "$ "+parseFloat(element.savings).toFixed(2),
              usd:  "$ "+parseFloat(element.USD).toFixed(2),
              frequency: element.frequency
            }
            
            let new_duration = new Date(element.duration)
            let start_date = new Date(element.dateStart)
            let add_year = new Date().getFullYear() - start_date.getFullYear()
            let add_year_d = new Date().getFullYear() - new_duration.getFullYear()
            let year = start_date.getFullYear();
            let month = start_date.getMonth();
            let day = start_date.getDate();
            start_date = new Date(year + add_year, month, day);
            year = new_duration.getFullYear();
            month = new_duration.getMonth();
            day = new_duration.getDate();
            new_duration = new Date(year + add_year_d, month, day);
            if(new_duration < start_date){
              new_duration = new Date(year + add_year_d, 12, 31);
            }
            timeItmes[idItem] = {
                id:idItem,
                rowId:element.childId,
                style:{
                  background:element.color
                },
                time:{
                  start: new Date(start_date).getTime(),
                  end: new Date(new_duration).getTime()
                }
            }
            let month_f = element.f_duration
            let new_start_month = 0
            
            if(month_f < 12)
            {
              let count = 4
              while (count < 12)
              {
                count = count + 1
                new_start_month = new_duration.getMonth() - start_date.getMonth();
                if(new_start_month > 0){
                  year = new Date().getFullYear();
                  month = start_date.getMonth();
                  day = start_date.getDate();
                  if(parseInt(month) +parseInt(new_start_month)+parseInt(month_f) < 12){
                    start_date = new Date(year, parseInt(month) +parseInt(new_start_month)+parseInt(month_f) , day);
                    year = new Date().getFullYear();
                    month = start_date.getMonth();
                    day = new_duration.getDate();
                    
                    new_duration = new Date(year, parseInt(month) + parseInt(new_start_month), day);
                    if((parseInt(month) + parseInt(new_start_month))>= 12){
                      new_duration = new Date(year, 12, 31);
                    }
                    //console.log(start_date,new_duration)
                    idItem = idItem + 1
                    timeItmes[idItem] = {
                        id:idItem,
                        rowId:element.childId,
                        style:{
                          background:element.color
                        },
                        time:{
                          start: new Date(start_date).getTime(),
                          end: new Date(new_duration).getTime()
                        }
                    }
                  }
                }
                
              }
            }

            
            idItem = idItem + 1
          })
          
          state.update('config.list.rows', item => {
            this.config.list.rows = rows
          })
          
          state.update('config.chart.items', item => {
            this.config.chart.items = timeItmes
          })
          state.update('config.height', (currentValue) => {
            this.config.height =  resHeight + 100
          })
       


          var elements = document.getElementsByClassName("gantt-schedule-timeline-calendar__list-column-header-resizer");
          while(elements.length > 0){
              elements[0].classList.remove("gantt-schedule-timeline-calendar__list-column-header-resizer");
          }
        })
        }else{
          let historial_selected=String(this.historial_yearSelected).split('-')
          gantt.rowsHistorial(id,historial_selected[0],historial_selected[1])
          .then((res) => {    
            let rows= {}
            let new_time= {}
            let timeItmes = {}
            let idItem = 1
            let resHeight = (res.data.parents.length + res.data.columns.length)*50
            this.resHeight = resHeight
            let total_savings = 0
            let total_USD  = 0 
            res.data.parents.forEach(element => {
              
                rows[element.parentId] ={
                  id:element.parentId,
                  label:element.parentName,
                  expanded: true,
                  saving: "$ "+parseFloat(element.savings).toFixed(2),
                  usd:  "$ "+parseFloat(element.USD).toFixed(2)
                }
                total_savings += +(element.savings)
                total_USD += +(element.USD)
               
              
            })
          rows['totals'] ={
            id:'totals',
            label:'Totals',
            expanded: false,
            saving: "$ "+parseFloat(total_savings).toFixed(2),
            usd:  "$ "+parseFloat(total_USD).toFixed(2)
          }
          let duration = '';
          res.data.columns.forEach(element => {
            duration = new Date(element.duration).getTime()
            rows[element.childId] = {
              id:element.childId,
              label: element.childName,
              expanded: false,
              parentId:element.parentId,
              saving: "$ "+parseFloat(element.savings).toFixed(2),
              usd:  "$ "+parseFloat(element.USD).toFixed(2),
              frequency: element.frequency
            }
            
            let new_duration = new Date(element.duration)
            let start_date = new Date(element.dateStart)
            let add_year = new Date().getFullYear() - start_date.getFullYear()
            let add_year_d = new Date().getFullYear() - new_duration.getFullYear()
            let year = start_date.getFullYear();
            let month = start_date.getMonth();
            let day = start_date.getDate();
            start_date = new Date(year + add_year, month, day);
            year = new_duration.getFullYear();
            month = new_duration.getMonth();
            day = new_duration.getDate();
            new_duration = new Date(year + add_year_d, month, day);
            if(new_duration < start_date){
              new_duration = new Date(year + add_year_d, 12, 31);
            }
            timeItmes[idItem] = {
                id:idItem,
                rowId:element.childId,
                style:{
                  background:element.color
                },
                time:{
                  start: new Date(start_date).getTime(),
                  end: new Date(new_duration).getTime()
                }
            }
            let month_f = element.f_duration
            let new_start_month = 0
            
            if(month_f < 12)
            {
              let count = 4
              while (count < 12)
              {
                count = count + 1
                new_start_month = new_duration.getMonth() - start_date.getMonth();
                if(new_start_month > 0){
                  year = new Date().getFullYear();
                  month = start_date.getMonth();
                  day = start_date.getDate();
                  if(parseInt(month) +parseInt(new_start_month)+parseInt(month_f) < 12){
                    start_date = new Date(year, parseInt(month) +parseInt(new_start_month)+parseInt(month_f) , day);
                    year = new Date().getFullYear();
                    month = start_date.getMonth();
                    day = new_duration.getDate();
                    
                    new_duration = new Date(year, parseInt(month) + parseInt(new_start_month), day);
                    if((parseInt(month) + parseInt(new_start_month))>= 12){
                      new_duration = new Date(year, 12, 31);
                    }
                    //console.log(start_date,new_duration)
                    idItem = idItem + 1
                    timeItmes[idItem] = {
                        id:idItem,
                        rowId:element.childId,
                        style:{
                          background:element.color
                        },
                        time:{
                          start: new Date(start_date).getTime(),
                          end: new Date(new_duration).getTime()
                        }
                    }
                  }
                }
                
              }
            }

            
            idItem = idItem + 1
          })
          
          state.update('config.list.rows', item => {
            this.config.list.rows = rows
          })
          
          state.update('config.chart.items', item => {
            this.config.chart.items = timeItmes
          })
          state.update('config.height', (currentValue) => {
            this.config.height =  resHeight + 100
          })
       


          var elements = document.getElementsByClassName("gantt-schedule-timeline-calendar__list-column-header-resizer");
          while(elements.length > 0){
              elements[0].classList.remove("gantt-schedule-timeline-calendar__list-column-header-resizer");
          }
        })
        }
        
      }//
    }
  },
  beforeDestroy () {
    subs.forEach(unsub => unsub())
  }
}
</script> 
<style>

/* .gantt-schedule-timeline-calendar__list-column:first-child{
  width: 80% !important;
} */
.gantt-schedule-timeline-calendar__list-column:nth-child(0n+2){
  max-width: 7rem !important;
}
.gantt-schedule-timeline-calendar__list-column:nth-child(0n+3){
  max-width: 7rem !important;
}
.gantt-schedule-timeline-calendar__list-column-row-content,.gantt-schedule-timeline-calendar__list-column-header-resizer-container{
  font-size: 90% !important;
}
.test{
  width: 100%;
  overflow-x: auto;
  white-space: nowrap;
}
/* .gantt-schedule-timeline-calendar__chart-calendar-date--month{
  width: calc(100%/12) !important;
} */
</style>
